/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const subscriptionDataSchema = z.object({
	hasSubscription: z.boolean(),
	planName: z.string().nullable(),
	addons: z.array(z.string()).default([]),
	status: z.string().nullable(),
	currentPeriodStart: z.iso.datetime().nullable(),
	currentPeriodEnd: z.iso.datetime().nullable(),
	nextBillingDate: z.iso.datetime().nullable(),
	endsAt: z.iso.datetime().nullable(),
	trialEndsAt: z.iso.datetime().nullable(),
	campaignFeePercentage: z.number().nullable(),
	profileId: z.string().nullable(),
	selfServe: z.boolean().default(false),
})

export type SubscriptionDataSchema = z.infer<typeof subscriptionDataSchema>
